import React from 'react';
import PropTypes from 'prop-types';
import { isOrderUnconfirmed } from '@bagonboard/wiseman';

import { ButtonDetails, Container } from './style';
import { historyPropTypes } from '../../../../../types';

const Details = ({ history, original, value }) => {
  const onDetailsClick = () => {
    history.push(`/order/${value}`);
  };
  const isForReview = isOrderUnconfirmed(original);
  return (
    <Container>
      <ButtonDetails
        isForReview={isForReview}
        onClick={onDetailsClick}
        variant="outlined"
      >
        {isForReview ? 'REVIEW' : 'DETAILS'}
      </ButtonDetails>
    </Container>
  );
};

Details.propTypes = {
  history : historyPropTypes.isRequired,
  original: PropTypes.shape({
    status: PropTypes.string,
  }),
  value: PropTypes.string,
};

Details.defaultProps = {
  original: {},
  value   : '',
};

export default Details;
